var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68374 15C1.40721 15.0001 1.15789 14.8335 1.05206 14.578C0.946233 14.3226 1.00474 14.0285 1.2003 13.833L13.833 1.20025C14.1 0.933252 14.5329 0.933252 14.7999 1.20025C15.0669 1.46724 15.0669 1.90012 14.7999 2.16711L2.16717 14.7999C2.03907 14.9282 1.86509 15.0003 1.68374 15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3165 15C14.1352 15.0003 13.9612 14.9282 13.8331 14.7999L1.20037 2.16711C0.933374 1.90012 0.933374 1.46724 1.20037 1.20025C1.46736 0.933252 1.90024 0.933252 2.16724 1.20025L14.8 13.833C14.9955 14.0285 15.054 14.3226 14.9482 14.578C14.8424 14.8335 14.5931 15.0001 14.3165 15Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCrossBlack);
export default __webpack_public_path__ + "static/media/ic_cross_black.6fa1752c341d2f1042902ceb3e5e64b9.svg";
export { ForwardRef as ReactComponent };